module.exports = __webpack_public_path__ + "static/media/shape0.pngfeat1.7a429b49.png";